__turbopack_context__.v({
  "advancedSearchLink": "BrandSearchPage-module-scss-module__0XvxEW__advancedSearchLink",
  "brandIdentity": "BrandSearchPage-module-scss-module__0XvxEW__brandIdentity",
  "brandInitial": "BrandSearchPage-module-scss-module__0XvxEW__brandInitial",
  "brandLogo": "BrandSearchPage-module-scss-module__0XvxEW__brandLogo",
  "brandName": "BrandSearchPage-module-scss-module__0XvxEW__brandName",
  "brandPage": "BrandSearchPage-module-scss-module__0XvxEW__brandPage",
  "brandTitle": "BrandSearchPage-module-scss-module__0XvxEW__brandTitle",
  "buttonContainer": "BrandSearchPage-module-scss-module__0XvxEW__buttonContainer",
  "closeContainer": "BrandSearchPage-module-scss-module__0XvxEW__closeContainer",
  "description": "BrandSearchPage-module-scss-module__0XvxEW__description",
  "descriptionSection": "BrandSearchPage-module-scss-module__0XvxEW__descriptionSection",
  "followButtonHidden": "BrandSearchPage-module-scss-module__0XvxEW__followButtonHidden",
  "mainContent": "BrandSearchPage-module-scss-module__0XvxEW__mainContent",
  "mobileBrandHeader": "BrandSearchPage-module-scss-module__0XvxEW__mobileBrandHeader",
  "mobileBrandIdentity": "BrandSearchPage-module-scss-module__0XvxEW__mobileBrandIdentity",
  "mobileBrandInfo": "BrandSearchPage-module-scss-module__0XvxEW__mobileBrandInfo",
  "mobilePopularModels": "BrandSearchPage-module-scss-module__0XvxEW__mobilePopularModels",
  "modelLink": "BrandSearchPage-module-scss-module__0XvxEW__modelLink",
  "modelsContainer": "BrandSearchPage-module-scss-module__0XvxEW__modelsContainer",
  "onlyLarge": "BrandSearchPage-module-scss-module__0XvxEW__onlyLarge",
  "popularModels": "BrandSearchPage-module-scss-module__0XvxEW__popularModels",
  "popularModelsSection": "BrandSearchPage-module-scss-module__0XvxEW__popularModelsSection",
  "readMoreButton": "BrandSearchPage-module-scss-module__0XvxEW__readMoreButton",
  "sidebar": "BrandSearchPage-module-scss-module__0XvxEW__sidebar",
  "sidebarContent": "BrandSearchPage-module-scss-module__0XvxEW__sidebarContent",
  "socialLink": "BrandSearchPage-module-scss-module__0XvxEW__socialLink",
  "socialLinks": "BrandSearchPage-module-scss-module__0XvxEW__socialLinks",
  "websiteLink": "BrandSearchPage-module-scss-module__0XvxEW__websiteLink",
});
